import React from 'react';
import './style.css';
const Banner4 = () => {
  return <div className="banner4-container"></div>;
};

export default Banner4;
